import _isValidNumber from './validate_';
import { sort_out_arguments } from './getNumberType';

// Finds out national phone number type (fixed line, mobile, etc)
export default function isValidNumber(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    input = _sort_out_arguments.input,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	return _isValidNumber(input, options, metadata);
}
//# sourceMappingURL=validate.js.map